import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from '@/_components/ui/pagination'

interface DataTablePaginationProps {
  currentPage: number
  totalPages: number
  totalCount: number
  canGoNext: boolean
  canGoPrevious: boolean
  onNextPage: () => void
  onPreviousPage: () => void
}

export function DataTablePagination({
  currentPage,
  totalPages,
  totalCount,
  canGoNext,
  canGoPrevious,
  onNextPage,
  onPreviousPage,
}: DataTablePaginationProps) {
  return (
    <div className="flex items-center justify-between px-2 py-2">
      <p className="text-sm text-muted-foreground">
        {totalCount} {totalCount === 1 ? 'resultado' : 'resultados'}
      </p>

      <div className="flex items-center gap-4">
        <p className="text-sm text-muted-foreground">
          Pagina {currentPage} de {totalPages}
        </p>

        <Pagination className="mx-0 w-auto">
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                onClick={onPreviousPage}
                aria-disabled={!canGoPrevious}
                className={!canGoPrevious ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationNext
                onClick={onNextPage}
                aria-disabled={!canGoNext}
                className={!canGoNext ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  )
}
